module.exports = __webpack_public_path__ + "2fc26e799d90f602a3dc57737fe42159.svg";